import React, {Component} from "react";
import {withTranslate} from "react-redux-multilingual";
import SectionHeader from "../home/SectionHeader";
import BlogCard from "./BlogCard";
import {setBlogCardSkeleton} from "../../skeleton";
import {Link} from "react-router-dom";

class BlogHome extends Component {

    render() {
        const {posts, loading} = this.props;
        const postsList = posts && posts.length ? posts.map((post, index) => {
            return (
                <div className="col-md-4" key={index}>
                    <BlogCard post={post}/>
                </div>
            )
        }) : null;
        return (
            postsList ? <section className="doctors-list" id="blog">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12 center">
                                    <SectionHeader header={this.props.translate("blog_header")}/>
                                </div>
                            </div>
                            <div className="row">
                                {loading === false ? postsList : setBlogCardSkeleton(3, 4)}
                            </div>

                            <div className="row" hidden={!posts.length}>
                                <div className="text-center full-width">
                                    <Link to="/blog" style={{pointerEvents: 'false'}} className="btn shadow-4d bolder"
                                    >{this.props.translate("fetch_more")}</Link>
                                </div>
                            </div>

                        </div>
                    </section> : null

        )
    }
}


export default withTranslate(BlogHome);

